module.exports = __webpack_public_path__ + "static/img/suoxiao.2045f68d.png";